import { render } from "./tardiness-reports.vue?vue&type=template&id=0971bb36&scoped=true"
import script from "./tardiness-reports.vue?vue&type=script&lang=js"
export * from "./tardiness-reports.vue?vue&type=script&lang=js"

import "./tardiness-reports.vue?vue&type=style&index=0&id=0971bb36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0971bb36"]])

export default __exports__